import { render, staticRenderFns } from "./DocumentsListComunications.vue?vue&type=template&id=1edd5973&scoped=true&"
import script from "./DocumentsListComunications.vue?vue&type=script&lang=js&"
export * from "./DocumentsListComunications.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsListComunications.vue?vue&type=style&index=0&id=1edd5973&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edd5973",
  null
  
)

export default component.exports